import { render, staticRenderFns } from "./PromotionsSingle.vue?vue&type=template&id=f3d53078&"
import script from "./PromotionsSingle.vue?vue&type=script&lang=js&"
export * from "./PromotionsSingle.vue?vue&type=script&lang=js&"
import style0 from "./PromotionsSingle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports